// @flow
import React from "react";
import styled from "styled-components";
import { media } from "@nested/ui";
import InvertedSwoosh from "../shared/Swoosh/InvertedSwoosh";
import { RichText } from "../shared/RichText";
import blob from "../LeftAlignedHero/images/blob.svg";
import withNavColour from "../../hocs/withNavColour/withNavColour";
import Blob from "../../components/Blob/Blob";
import addScrollHandler from "./addScrollHandler";

const BottomBlobWrapper = styled.div`
  bottom: 0;
  height: 150px;
  left: -150px;
  overflow: hidden;
  position: absolute;
  ${media.tablet`
    left: -110px;
  `} ${media.desktop`
    left: 0;
    height: 220px;
    width: 355px;
  `};
`;

const BottomBlob = styled(Blob)`
  height: 250px;
  ${media.desktop`
    height: 600px;
    width: 560px;
    position: relative;
    left: -200px;
  `};
`;

const DownArrow = styled.img`
  cursor: pointer;
  display: block;
  height: 100px;
  margin: auto;
  position: relative;
  top: -50px;
  width: 100px;
`;

const JumpLinkTitleWrapper = styled(RichText)`
  margin-top: 90px;
  padding-bottom: 10px;
`;

const SwooshWrapper = styled.div`
  bottom: 0;
  position: absolute;
  width: 100%;
`;

const TextWrapper = styled(RichText)`
  position: relative;
  z-index: 2;
  padding-left: 10px;
  padding-right: 10px;
  && h1 {
    max-width: 790px;
  }

  && p {
    max-width: 550px;
  }
`;

const TopBlobWrapper = styled.div`
  height: 250px;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: -100px;
  width: 44px;
  ${media.tablet`
    width: 112px;
  `} ${media.desktop`
    top: -192px;
    height: 500px;
    width: 204px;
  `};
`;

const TopBlob = styled(Blob)`
  height: 250px;
  ${media.desktop`
    height: 500px;
    width: 467px;
  `};
`;

const Background = styled.div`
  background-color: ${({ colour, shade, theme }) =>
    theme.palette[colour][shade]};
  padding-bottom: 25px;
  padding-top: 150px;
  position: relative;
`;

const Wrapper = styled.section`
  padding-bottom: 50px;
  background-color: ${({ colour, theme }) => theme.palette[colour].extraLight};
`;

type Props = {
  colour: string,
  heroText: any[],
  jumpLinkTitle: any[],
  shade: "extraLight" | "light" | "medium",
  swooshBackgroundColour: string,
};

class CentredHero extends React.Component<Props> {
  componentDidMount() {
    addScrollHandler();
  }

  render() {
    const {
      colour,
      heroText,
      jumpLinkTitle,
      shade = "medium",
      swooshBackgroundColour = "white",
    } = this.props;

    return (
      <Wrapper colour={swooshBackgroundColour}>
        <Background colour={colour} shade={shade}>
          <TopBlobWrapper>
            <TopBlob colour={colour} shade="dark" />
          </TopBlobWrapper>
          <TextWrapper center>{heroText}</TextWrapper>
          <JumpLinkTitleWrapper center>{jumpLinkTitle}</JumpLinkTitleWrapper>
          <BottomBlobWrapper>
            <BottomBlob colour={colour} shade="dark" />
          </BottomBlobWrapper>
          <SwooshWrapper>
            <InvertedSwoosh
              position="bottom"
              colour={swooshBackgroundColour}
              shade="extraLight"
            >
              <DownArrow id="hero-scroll-down" src={blob} alt="Down arrow" />
            </InvertedSwoosh>
          </SwooshWrapper>
        </Background>
      </Wrapper>
    );
  }
}

export default withNavColour(CentredHero);
